import { TRANSFER_ACTIONS } from "../../constants";

export const bindTransfer = (payload) => {
    return {
        type: TRANSFER_ACTIONS.BLIND_TRANSFER,
        payload: payload
    }
}

export const resetTransfer = () => {
    return {
        type: TRANSFER_ACTIONS.RESET_BLIND_TRANSFER
    }
}

export const assistedErrorTransfer = (payload) => {
    return {
        type: TRANSFER_ACTIONS.ASSISTED_TRANSFER,
        payload: payload
    }
}

export const resetAssistedErrorTransfer = () => {
    return {
        type: TRANSFER_ACTIONS.RESET_ASSISTED_TRANSFER
    }
}
export const showDataTransferBySetting = (payload) => {
    return {
        type: TRANSFER_ACTIONS.SHOW_DATA_TRANSGER_BY_SETTING,
        payload: payload
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/A_transfer.js